export default function PrintOnly() {
  return <></>;
}
